import { Component, Input } from '@angular/core';
import ProductHelper from 'src/app/helpers/product-helper';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import { FileHelper } from '../../../helpers/file-helper';

@Component({
  selector: 'adjustment-other-product-summary',
  templateUrl: './adjustment-other-product-summary.component.html',
  styleUrls: ['./adjustment-other-product-summary.component.scss'],
})
export class AdjustmentOtherProductSummaryComponent {
  @Input()
  product: OtherProduct;

  @Input()
  index: number;

  @Input()
  multipleProducts: boolean;

  isImage = FileHelper.isImage;

  getProductType(type: string, otherProductName: string) {
    return ProductHelper.getType(type, otherProductName);
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 8 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }
}
